<template>
  <div>
    <div class="bg-custom" style="height:100vh">
      <div class="container h-100">
        <div class="d-flex justify-content-center align-items-center h-100">
            <!-- Left Side: Background Color Section -->
             <div class="d-flex"  style="height: 50vh">
              <div class="transparent-bg p-5 mb-0 d-flex justify-content-center align-items-center h-100">
                <div class="mx-auto">
                  <a routerLink="/">
                    <h3 class="d-inline align-middle ml-1 text-logo">
                      Talent
                    </h3>
                  </a>
                </div>
              </div>
              <div class="card h-100 border-radius-right">
                <div class="card-body p-0">
                  <div class="d-flex">

                    <!-- Right Side: Form Section -->
                    <div class="p-5">
                      <h6 class="h5 mb-0 mt-4">{{ $t('login.welcome_title') }}</h6>
                      <p class="text-muted mt-1 mb-4">
                        {{ resetPassword ? $t('login.reset_message') : $t('login.welcome_message') }}
                      </p>

                      <b-alert variant="danger" dismissible v-if="errorMessage">
                        {{ errorMessage }}
                      </b-alert>

                      <b-form class="authentication-form" @submit.prevent="handleFormSubmit" v-if="!resetPassword">
                        <TextField 
                          :placeholder="$t('login.email_placeholder')"
                          :label="$t('login.email_label')"
                          icon="mail"
                          name="email"
                          v-model="model.email"
                          :validator="$v.model.email"
                        />

                        <TextField 
                          :placeholder="$t('login.password_placeholder')"
                          :label="$t('login.password_label')"
                          icon="lock"
                          name="password"
                          type="password"
                          v-model="model.password"
                          :validator="$v.model.password"
                        />
                        <div class="text-danger" v-if="$v.model.email.errorMessage">
                          {{ $v.model.email.errorMessage }}
                        </div>
                        <div class="text-danger" v-if="$v.model.email.$error">
                          Please provide a valid email
                        </div>
                        <div class="text-danger" v-if="$v.model.password.errorMessage">
                          {{ $v.model.password.errorMessage }}
                        </div>
                        <div class="text-danger" v-if="$v.model.password.$error">
                          Please provide a valid password
                        </div>

                        <b-form-group id="button-group" class="mt-4 mb-1">
                          <Button class="btn-block" :loading="loading">{{ $t('login.signin_button') }}</Button>
                        </b-form-group>
                      </b-form>
                      <!-- Reset Password Form -->
                      <b-form class="authentication-form" @submit.prevent="resetPassword" v-else>
                        <TextField 
                          :placeholder="$t('login.email_placeholder')"
                          :label="$t('login.email_label')"
                          icon="mail"
                          name="email"
                          v-model="model.email"
                          :error="$v.model.email.$error"
                          :errorMessage="$v.model.email.errorMessage"
                          :validator="$v.model.email"
                        />

                        <b-form-group id="button-group" class="mt-4 mb-1">
                          <Button class="btn-block" :loading="loading">Reset Password</Button>
                          <Button class="btn btn-secondary btn-block" :loading="loading" @click="cancelReset">Cancel</Button>
                        </b-form-group>
                      </b-form>

                      <p v-if="!resetPassword" class="text-muted">
                        Forgotten your password?
                        <router-link tag="a" to="" class="text-primary font-weight-bold ml-1" @click.native="toggleResetPassword">Reset Password</router-link>
                      </p>
                      <div class="row mt-3">
                        <div class="col-12 text-center">
                          <Version />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             </div>
          
        </div>
      </div>
    </div>

    <!-- Success Modal -->
    <b-modal title="Success" id="bv-modal-message" hide-footer>
      <div class="d-block text-center">
        <h5>{{ resetMsg }}</h5>
      </div>
      <b-button class="mt-3 btn2 btn2-primary btn-sm mr-1" block @click="closeResetModal">Ok</b-button>
    </b-modal>
  </div>
</template>

<script>
import Version from '@components/version.vue'
import Button from '@components/buttons/button'
import TextField from '@components/form/textfield'
import FormMixin from '@mixins/form'
import error from '@utils/error'

import { required, email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  mixins: [FormMixin],
  name: 'login',
  data() {
    return {
      model: {
        email: "",
        password: ""
      },
      resetPassword: false,
      resetMsg: '',
      errorMessage: '',  // Stores error messages for form validation
      loading: false
    }
  },
  components: {
    Version, Button, TextField
  },
  mounted() {
    // this.$refs['language'].value = this.$cookie.get('language')
    // this.$i18n.locale = this.$cookie.get('language')
  },
  methods: {
    ...mapActions('user', ['reset']),
    
    toggleResetPassword() {
      this.resetPassword = !this.resetPassword
    },

    async handleFormSubmit() {
      this.loading = true;
      this.errorMessage = ''; // Reset error message before submit

      if (this.resetPassword) {
        this.resetPasswordAction();
      } else {
        const isLogin = await this.loginUser();
        if(!isLogin.success){
          this.loading = false;
          this.errorMessage = isLogin.message;
          this.$bvToast.toast(isLogin.message, {
            title: 'Login Warning!',
            autoHideDelay: 3000,
            appendToast: true,
            variant: 'danger',
          })
        }
      }
    },

    resetPasswordAction() {
      let user = { email: this.model.email };
      this.reset(user)
        .then(res => {
          if (res.data.success) {
            this.resetMsg = res.data.message;
            this.$bvModal.show('bv-modal-message');
            this.toggleResetPassword();
            this.model.password = '';
          } else {
            this.errorMessage = res.data.message;
          }
        })
        .catch(err => {
          this.errorMessage = error.errorHandler(err, this.$bvToast);
        })
        .finally(() => this.loading = false);
    },

    // loginUser() {
    //   // Handle login functionality here
    // },

    closeResetModal() {
      this.$bvModal.hide('bv-modal-message');
    },

    cancelReset() {
      this.toggleResetPassword();
      this.model.password = '';
    }
  },
  validations: {
    model: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  }
}
</script>

<style scoped>
/* Left section background color */
.bg-light {
  background-color: #f4f6f9; /* Change this color if needed */
}

/* Centered form section on the right */
.card-body .row {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Button customization */
.btn-block {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border-radius: 5px;
  border: none;
}

.bg-custom {
  background-image: url('../../../assets/images/building-bg.jpg'); /* or relative path */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.transparent-bg{
  backdrop-filter: blur(8px); 
  background-color: rgba(255, 255, 255, 0.5); 
  border-radius: 0.625rem 0 0 0.635rem;
}
.border-radius-right{
  border-radius: 0 0.625rem 0.635rem 0;
}

</style>
